import { render, staticRenderFns } from "./AgregarDatosFiscales.vue?vue&type=template&id=9dab6270&scoped=true"
import script from "./AgregarDatosFiscales.vue?vue&type=script&lang=js"
export * from "./AgregarDatosFiscales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dab6270",
  null
  
)

export default component.exports